export const HISTORY_NAMESPACE = 'history';
